import { useRef, forwardRef, useState, useEffect, useImperativeHandle } from "react";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { Autocomplete, Box, Checkbox, Divider, ListItemText, MenuItem, Popper, Select, TextField, autocompleteClasses, useTheme } from "@mui/material";
import jwtDecode from "jwt-decode";
import { styled } from "@mui/styles";
import moment from "moment";

const StyledPopper = styled(Popper)(({ theme }) => ({
  [`& .${autocompleteClasses.listbox}`]: {
    boxSizing: 'border-box',
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    fontSize: '11px',
    '& li': {
      padding: '3px 8px',
    },
  },
}));
export const CustomerEditorComponent = forwardRef((props, ref) => {
    const [customer, setCustomer] = useState(props.value || '')
    const [custId, setCustId] = useState(props?.data?.custNum);
    const token = (localStorage && localStorage.getItem('token')) && jwtDecode(localStorage.getItem('token'));
    const refInput = useRef();
    const theme = useTheme();
const customerOptions =
    props.customerOptions ||
    props?.params?.customerOptions || 
    props?.context?.customerOptions || []; 

    const handleCustomerChange = (e, data) => {
        data.label && setCustomer(data.label);
        data.id && setCustId(data.id);
        const rowData = props.node;
        data.name && rowData.setDataValue('custName', data.label)
        data.id && rowData.setDataValue('custNum', data.id)
    };

    useEffect(() => {
        window.setTimeout(() => {
            const eInput = refInput.current;
            eInput.focus();
        });
    }, []);
const clearCustomerSelection = () => {
    setCustomer('');
    setCustId('');
    
    const rowData = props.node;
    rowData.setDataValue('custName', '');
    rowData.setDataValue('custNum', '');
};
    useImperativeHandle(ref, () => {
        return {
            getValue() {
                const rowNode = props.node;
                rowNode.setDataValue('custNum', custId);

                return customer;
            },
            getCustNum() {
                return custId;
            },
            focusIn() {
                var eInput = refInput.current;
                eInput.focus();
                eInput.select();
            },
        }
    });

    return (
      <Autocomplete
        options={customerOptions}
         freeSolo={false}
        value={
          customer && customerOptions.length > 0
            ? customerOptions.find(
                (obj) =>
                  obj.name.trim() === customer.trim() ||
                  obj.label.trim() === customer.trim()
              ) || null
            : null
        }
        onChange={(e, value) => {
          if (value === null) {
            clearCustomerSelection();
          } else {
            handleCustomerChange(e, value);
          }
        }}
        disableClearable={false}
        PopperComponent={StyledPopper}
        size="small"
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={"Select"}
            inputRef={refInput}
            className="customDatePickerDiscount"
            size="small"
            sx={{
              fontSize: "12px",
              backgroundColor: theme.palette. background.paper,
            }}
          />
        )}
      />
    );
});
export const CustomerIdEditorComponent = forwardRef((props, ref) => {
  const vendorOptions = props.customerOptions || [];
  const [vendId, setVendId] = useState(props.value);
  const refInput = useRef();
     const theme = useTheme();
  useEffect(() => {
    setTimeout(() => {
      refInput.current?.focus();
    });
  }, []);

  const handleVendorChange = (event, newValue) => {
    if (newValue) {
      setVendId(newValue.value);
      props.node.setDataValue("customerId", newValue.value);
    } else {
      setVendId(null);
      props.node.setDataValue("customerId", null);
    }
  };

  useImperativeHandle(ref, () => ({
    getValue() {
      return vendId;
    },
    focusIn() {
      refInput.current?.focus();
    },
  }));

  return (
    <Autocomplete
      options={vendorOptions}
      value={vendorOptions.find((opt) => opt.value === vendId) || null}
      onChange={handleVendorChange}
      disableClearable
      size="small"
      PopperComponent={StyledPopper}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Select Customer"
          inputRef={refInput}
          size="small"
          sx={{
            fontSize: "smaller",
            backgroundColor: theme.palette. background.paper,
          }}
        />
      )}
    />
  );
});
export const ProductEditorComponent = forwardRef((props, ref) => {
    const [product, setProduct] = useState(props.value)
    const [productOptions, setProductOptions] = useState([]);
    const [prodId, setProdId] = useState(props.data.productIds);
    const [vendorId, setVendorId] = useState();
    const [checkCriteria, setCheckCriteria] = useState(props.data.criteria)
     const theme = useTheme();
    const refInput = useRef();
    const getRangeList = async () => {
        const productsurl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.ranges}`;
        try {
            const products = await OAuthService.getList(productsurl+ `/search/findRangeByVendor?vendorId=${vendorId || props.data.vendorNum}`);
            const result = []
            products?.data?._embedded?.ranges.map((value) => {
                    if(value.active){
                        result.push({ label: value.productName + (value.productId ? ' (' + value.productId + ")" : ''), value: value.productName, id: value.id });
                    }
      
                    return { label: value.productName + ' (' + value.productId + ")", value: value.productName, id: value.id };
            });
               result.unshift({ label: 'All', value: 'All', id: 'all' });
            setProductOptions(result);
        } catch (error) {
        }
    }
    const getHandleList = async () => {
        const productsurl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.handles}`;
        try {
            const products = await OAuthService.getList(productsurl+ `/search/findAllHandlesByVendor?vendorId=${vendorId || props.data.vendorNum}`);
            const result = []
            products?.data?._embedded?.handles.map((value) => {
                    if(value.active){
                        result.push({ label: value.productName + (value.productId ? ' (' + value.productId + ")" : ''), value: value.productName, id: value.id });
                    }
                    return { label: value.productName + ' (' + value.productId + ")", value: value.productName, id: value.id };
            });
               result.unshift({ label: 'All', value: 'All', id: 'all' });
            setProductOptions(result);
        } catch (error) {
        }
    }
    useEffect(() => {
        props.api?.getCellEditorInstances().map((editor) => {
            if (editor?.getVendorID) {
                setVendorId(editor.getVendorID());

            }
        })
    }, []);

    useEffect(() => {
        if (checkCriteria === 'Range' && props.data.enablePromoDisc) {
            getRangeList()
        } else if (checkCriteria === 'Handle' && props.data.enablePromoDisc) {
            getHandleList()
        } else if (checkCriteria === 'Price Group' && props.data.enablePromoDisc) {
            getPriceGroupList()
        }
    }, [vendorId])

    useEffect(() => {
        window.setTimeout(() => {
            const eInput = refInput.current;
            eInput.focus();
        });
    }, []);

    const handleProductChange = (e, data) => {
        data.label ? setProduct([data.value]) : data ? setProduct(data) : setProduct([]);
        data.id && setProdId([data.id])
        const rowData = props.node;
        if ((checkCriteria === 'Handle' || checkCriteria === 'Range')) {
            data.value && rowData.setDataValue('productNames', data.value ? [data.value] : [])
            data.id && rowData.setDataValue('productIds', [data.id])
            rowData.setDataValue('priceGroupNames', [])
        } else if (checkCriteria === 'Price Group') {
            data.value && rowData.setDataValue('priceGroupNames', [data.value])
            rowData.setDataValue('productIds', [])
        }
    };

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                const rowNode = props.node;
                if ((checkCriteria === 'Handle' || checkCriteria === 'Range')) {
                    rowNode.setDataValue('productIds', prodId)
                    rowNode.setDataValue('priceGroupNames', [])
                } else if (checkCriteria === 'Price Group') {
                    rowNode.setDataValue('priceGroupNames', product)
                    rowNode.setDataValue('productIds', [])
                }
                return product;
            },
            focusIn() {
                var eInput = refInput.current;
                eInput.focus();
                eInput.select();
            },
        };
    });
   const getPriceGroupList = async () => {
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.material}`;
    try {
        const priceGroups = await OAuthService.getList(
            url + `/getPriceGroupsByVendor?vendorId=${vendorId || props.data.vendorNum}`
        );
        const result = priceGroups?.data?.map((pg) => ({
            id: pg,
            label: pg,
            value: pg
        }));
           result.unshift({ label: 'All', value: 'All', id: 'all' });
        setProductOptions(result);
    } catch (error) {
        console.error("Error fetching price groups:", error);
    }
};

    const handleFocus = () => {
        props.api?.getCellEditorInstances().map((editor) => {
            if (editor?.getCriteria) {
                setCheckCriteria(editor.getCriteria());
                if (editor.getCriteria() === 'Price Group') {
                    getPriceGroupList()
                } else if (editor.getCriteria() === 'Range') {
                    getRangeList()
                } else if (editor.getCriteria() === 'Handle') {
                    getHandleList()
                }
            } else if (editor?.getVendorID) {
                setVendorId(editor.getVendorID());
            }
        })
    }

    return (
        <Autocomplete
            options={productOptions}
            value={(product && productOptions.length > 0) ? (productOptions.filter((obj) => obj.value === product || product.includes(obj.value)) ? productOptions.filter((obj) => obj.value === product || product.includes(obj.value))[0] : '') : ''}
            onChange={handleProductChange}
            onInputChange={handleProductChange}
            onFocus={handleFocus}
            disableClearable
            PopperComponent={StyledPopper}
            renderInput={(params) => (
                <TextField
                    {...params}
                    sx={{ fontSize: 'smaller', backgroundColor: theme.palette. background.paper }}
                    inputRef={refInput}
                    className="customDatePickerDiscount"
                    size="small"
                    placeholder={'Select '}
                />
            )}
        />
    );
});

export const VendorEditorComponent = forwardRef((props, ref) => {
    const [vendor, setVendor] = useState(props.value)
    const [vendorOptions, setVendorOptions] = useState([]);
    const [vendId, setVendId] = useState(props.data.vendorNum);
    const refInput = useRef();
     const theme = useTheme();
    const getVendorList = async () => {
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}/search/findByActive?active=true`;
        try {
            const vendors = await OAuthService.getList(url);
            const result = vendors?.data?._embedded?.factoryVendors.map((value) => {
                return { label: value.shortKey, value: value.name, id: value.id };
            });
            setVendorOptions(result);
        } catch (error) {
        }
    }
    useEffect(() => {
        getVendorList();
    }, []);

    const handleVendorChange = (e, data) => {
        data.label && setVendor(data.label)
        data.id && setVendId(data.id)
        const rowData = props.node;
        data.label && rowData.setDataValue('vendorName', data.label)
        data.id && rowData.setDataValue('vendorNum', data.id)
    };

    useEffect(() => {
        window.setTimeout(() => {
            const eInput = refInput.current;
            eInput.focus();
        });
    }, []);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                const rowNode = props.node;
                rowNode.setDataValue('vendorNum', vendId)
                rowNode.setDataValue('vendorName', vendor)
                return vendor;
            },
            getVendorID() {
                return vendId
            },
            focusIn() {
                var eInput = refInput.current;
                eInput.focus();
                eInput.select();
            },
        };
    });

    return (
        <Autocomplete
            options={vendorOptions}
            value={(vendId && vendorOptions.length > 0) ? (vendorOptions.filter((obj) => obj.id === vendId) ? vendorOptions.filter((obj) => obj.id === vendId)[0] : '') : ''}
            onChange={handleVendorChange}
            onInputChange={handleVendorChange}
            disableClearable
            PopperComponent={StyledPopper}
            size="small"
            renderInput={(params) => (
                <TextField
                    {...params}
                    size="small"
                    placeholder={'Select '}
                    inputRef={refInput}
                    className="customDatePickerDiscount"
                    sx={{ fontSize: 'smaller', backgroundColor: theme.palette. background.paper }}
                />
            )}
        />
    );
});

export const VendorIdEditorComponent = forwardRef((props, ref) => {
  const vendorOptions = props.vendorOptions || [];
  const [vendId, setVendId] = useState(props.value);
  const refInput = useRef();
     const theme = useTheme();
  useEffect(() => {
    setTimeout(() => {
      refInput.current?.focus();
    });
  }, []);

  const handleVendorChange = (event, newValue) => {
    if (newValue) {
      setVendId(newValue.value);
      props.node.setDataValue("vendorId", newValue.value);
    } else {
      setVendId(null);
      props.node.setDataValue("vendorId", null);
    }
  };

  useImperativeHandle(ref, () => ({
    getValue() {
      return vendId;
    },
    focusIn() {
      refInput.current?.focus();
    },
  }));

  return (
    <Autocomplete
      options={vendorOptions}
      value={vendorOptions.find((opt) => opt.value === vendId) || null}
      onChange={handleVendorChange}
      disableClearable
      size="small"
      PopperComponent={StyledPopper}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Select Vendor"
          inputRef={refInput}
          size="small"
          sx={{
            fontSize: "smaller",
            backgroundColor: theme.palette. background.paper,
          }}
        />
      )}
    />
  );
});
export const MultipleVendorEditorComponent = forwardRef((props, ref) => {
  const vendorOptions = props.vendorOptions || [];

  const [selectedVendorIds, setSelectedVendorIds] = useState(
    Array.isArray(props.value) ? props.value : [],
  );
  const [open, setOpen] = useState(false);

  const selectRef = useRef();
  const theme = useTheme();

  const realVendorValues = vendorOptions
    .filter((opt) => opt.value !== "ALL")
    .map((opt) => opt.value);

  const isAllSelected =
    realVendorValues.length > 0 &&
    realVendorValues.every((v) => selectedVendorIds.includes(v)) &&
    selectedVendorIds.length === realVendorValues.length;

  const handleChange = (event) => {
    const values = event.target.value;

    if (values.includes(CLEAR_SELECTION)) {
      setSelectedVendorIds([]);
      props.node.setDataValue("vendorId", []);
      return;
    }

    if (values.includes("ALL")) {
      setSelectedVendorIds(realVendorValues);
      props.node.setDataValue("vendorId", realVendorValues);
      return;
    }

    setSelectedVendorIds(values);
    props.node.setDataValue("vendorId", values);
  };

  useImperativeHandle(ref, () => ({
    getValue() {
      return selectedVendorIds;
    },

    focusIn() {
      selectRef.current?.focus();
    },
  }));

  const renderSelectedSummary = () => {
    if (!selectedVendorIds || selectedVendorIds.length === 0) {
      return <span style={{ opacity: 0.6 }}>Select Vendor(s)</span>;
    }

    if (isAllSelected) {
      return "ALL";
    }

    if (selectedVendorIds.length === 1) {
      const option = vendorOptions.find(
        (opt) => opt.value === selectedVendorIds[0],
      );
      return option ? option.label : selectedVendorIds[0];
    }

    return `${selectedVendorIds.length} Vendors Selected`;
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <Select
        multiple
        fullWidth
        displayEmpty
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        value={selectedVendorIds}
        onChange={handleChange}
        renderValue={renderSelectedSummary}
        inputRef={selectRef}
        size="small"
        MenuProps={{
          transitionDuration: 150,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          PaperProps: {
            sx: {
              maxHeight: 320,
              mt: "2px",
              backgroundColor: theme.palette.background.paper,
              fontSize: "11px",
              "& .MuiList-root": {
                py: 0,
              },
            },
          },
        }}
        sx={{
          height: "100%",
          backgroundColor: theme.palette.background.paper,
          transition: "border-color 0.15s ease, box-shadow 0.15s ease",
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            height: "100% !important",
            paddingTop: 0,
            paddingBottom: 0,
            boxSizing: "border-box",
          },
        }}
      >
        <MenuItem
          value={CLEAR_SELECTION}
          dense
          sx={{
            fontStyle: "italic",
            opacity: 0.85,
            minHeight: "auto",
            fontSize: "11px",
            padding: "3px 8px",
          }}
        >
          Clear Selection
        </MenuItem>
        <Divider sx={{ my: 0 }} />
        {vendorOptions.map((option) => {
          const checked =
            option.value === "ALL"
              ? isAllSelected
              : selectedVendorIds.includes(option.value);

          return (
            <MenuItem
              key={option.value}
              value={option.value}
              dense
              sx={{ minHeight: "auto", fontSize: "11px", padding: "3px 8px" }}
            >
              <Checkbox size="small" checked={checked} sx={{ p: "2px", mr: "4px" }} />
              <ListItemText
                primary={option.label}
                primaryTypographyProps={{ fontSize: "11px" }}
              />
            </MenuItem>
          );
        })}
      </Select>
    </Box>
  );
});
export const DateTypeEditorComponent = forwardRef((props, ref) => {
  const dateTypeOptions = [
    { label: "Order placed", value: "ORDERPLACED" },
    { label: "Planned loading", value: "PLANNED_LOADING" },
  ];

  const [selectedValue, setSelectedValue] = useState(props.value ||"ORDERPLACED");
  const refInput = useRef();
   const theme = useTheme();
  useEffect(() => {
      if (!props.value) {
      props.node.setDataValue("dateType", "ORDERPLACED");
    }
    setTimeout(() => {
      if (refInput.current) {
        refInput.current.focus();
      }
    });
  }, []);

  const handleChange = (event, newValue) => {
    if (newValue) {
      setSelectedValue(newValue.value);
      props.node.setDataValue("dateType", newValue.value);
    } else {
      setSelectedValue(null);
      props.node.setDataValue("dateType", null);
    }
  };

  useImperativeHandle(ref, () => ({
    getValue() {
      return selectedValue;
    },
    focusIn() {
      if (refInput.current) {
        refInput.current.focus();
      }
    },
  }));

  return (
    <Autocomplete
      options={dateTypeOptions}
      value={dateTypeOptions.find((opt) => opt.value === selectedValue) || null}
      onChange={handleChange}
      disableClearable
      size="small"
      renderInput={(params) => (
        <TextField
          {...params}
          inputRef={refInput}
          placeholder="Select date type"
          size="small"
          sx={{
            fontSize: "smaller",
            backgroundColor: theme.palette. background.paper,
          }}
        />
      )}
    />
  );
});
export const ShowroomEditorComponent = forwardRef((props, ref) => {
    const [showroom, setShowroom] = useState(props.value === 'All' ? 'ALL' : props.value);
    const [showroomOptions, setShowroomOptions] = useState([]);
    const [showroomId, setShowroomId] = useState(props.data.showroomNum);
    const [custId, setCustId] = useState(props.data.custNum);
    const refInput = useRef();
     const theme = useTheme();
    const getAllShowrooms = async () => {
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.showrooms}/search/findByActiveTrue`;
        try {
            const res = await OAuthService.getList(url);
            const result = [{ label: "ALL" }];
            res?.data?._embedded?.showrooms?.forEach((s) => {
                result.push({ label:`${s.id}-${s.name}`, id: s.id });
            });
            setShowroomOptions(result);
        } catch (error) {
            console.error("Error fetching all showrooms", error);
        }
    };

    const getCustomerShowrooms = async (customerId) => {
        if (!customerId) return;
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.companies}/${customerId}/showrooms?size=1000`;
        try {
            const res = await OAuthService.getList(url);
            const result = [{ label: "ALL" }];
            res?.data?._embedded?.showrooms?.forEach((s) => {
                if (s.active) result.push({ label: `${s.id}-${s.name}`, id: s.id });
            });
            setShowroomOptions(result);
        } catch (error) {
            console.error("Error fetching customer showrooms", error);
        }
    };

    useEffect(() => {
        if (custId) {
            getCustomerShowrooms(custId);
        } else {
            getAllShowrooms();
        }
    }, [custId]);

    const handleShowroomChange = (e, data) => {
        if (!data) return;
        const { label, id } = data;
        setShowroom(label);
        setShowroomId(id);
        const rowNode = props.node;
        rowNode.setDataValue('showroomName', label);
        rowNode.setDataValue('showroomNum', id);
    };

    useEffect(() => {
        window.setTimeout(() => refInput.current?.focus(), 0);
    }, []);

    useImperativeHandle(ref, () => ({
        getValue() {
            props.node.setDataValue('showroomNum', showroomId);
            return showroom;
        },
        focusIn() {
            refInput.current?.focus();
            refInput.current?.select();
        },
        getCustNum() {
            return custId;
        },
        updateCustomerId(newCustId) {
            if (newCustId && newCustId !== custId) {
                setCustId(newCustId);
                getCustomerShowrooms(newCustId);
            }
        }
    }));

    return (
        <Autocomplete
            options={showroomOptions}
            getOptionLabel={(opt) => opt?.label || ""}
            value={showroomOptions.find((opt) => opt.label === showroom) || null}
            onChange={handleShowroomChange}
            disableClearable
            PopperComponent={StyledPopper}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder="Select"
                    size="small"
                    sx={{ fontSize: 'smaller', backgroundColor: theme.palette. background.paper }}
                    inputRef={refInput}
                    className="customDatePickerDiscount"
                />
            )}
        />
    );
});



export const PriceGroupEditorComponent = forwardRef((props, ref) => {
    const [priceGroup, setPriceGroup] = useState(props.value)
    const [priceGroupOptions, setPriceGroupOptions] = useState([]);
    const [checkCriteria, setCheckCriteria] = useState(props.data.criteria)
    const refInput = useRef();
     const theme = useTheme();
    const getPriceGroupList = async () => {
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.priceGroup}`;
        try {
            const priceGroups = await OAuthService.getList(url + `?size=1000`);
            const result = priceGroups?.data?._embedded?.priceGroups.map((value) => {
                return value.pgId;
            });
            setPriceGroupOptions(result);
        } catch (error) {
        }
    }
    useEffect(() => {
        getPriceGroupList();
        if (checkCriteria !== 'Price Group' && props.data.enablePromoDisc) {
            setPriceGroupOptions([])
        }
    }, []);

    const handlePriceGroupChange = (e, data) => {
        setPriceGroup([data]);
        const rowData = props.node;
        rowData.setDataValue('priceGroupNames', [data])
    };

    useEffect(() => {
        window.setTimeout(() => {
            const eInput = refInput.current;
            eInput.focus();
        });
    }, []);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return priceGroup;
            },
            focusIn() {
                var eInput = refInput.current;
                eInput.focus();
                eInput.select();
            },
        };
    });
    const handleFocus = () => {
        props.api?.getCellEditorInstances().map((editor) => {
            if (editor?.getCriteria) {
                setCheckCriteria(editor.getCriteria());
                if (editor.getCriteria() === 'Price Group') {
                    getPriceGroupList();
                }
            }
        })
    }

    return (
        <Autocomplete
            options={priceGroupOptions}
            value={priceGroup}
            onChange={handlePriceGroupChange}
            onInputChange={handlePriceGroupChange}
            onFocus={handleFocus}
            disableClearable
            PopperComponent={StyledPopper}
            renderInput={(params) => (
                <TextField
                    {...params}
                    inputRef={refInput}
                    className="customDatePickerDiscount"
                    size="small"
                    sx={{ fontSize: 'smaller', backgroundColor: theme.palette. background.paper }}
                    placeholder={'Select '}
                />
            )}
        />
    );
});

export const OrderCategoryEditorComponent = forwardRef((props, ref) => {
    const [orderCategory, setOrderCategory] = useState(props.value)
    const [orderCategoryFullName, setOrderCategoryFullName] = useState(props.value)
    const [orderCategoryOptions, setOrderCategoryOptions] = useState([]);
    const refInput = useRef();
     const theme = useTheme();
    const getOrderCategoryList = async () => {
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.orderCategories}`;
        try {
            const orderCategories = await OAuthService.getList(url + `?size=1000`);
            const result = orderCategories?.data?._embedded?.orderCategories.map((value) => {
                return {value:value.name, label: value.name,name: value.displayName};
            });
            setOrderCategoryOptions(result);
        } catch (error) {
        }
    }
    useEffect(() => {
        getOrderCategoryList();
    }, []);

    const handleOrderCategoryChange = (e, data) => {
        setOrderCategory(data?.value);
        setOrderCategoryFullName(data?.name);
        const rowData = props.node;
        rowData.setDataValue('orderCategoryName', data?.value)
    };

    useEffect(() => {
        window.setTimeout(() => {
            const eInput = refInput.current;
            eInput.focus();
        });
    }, []);
    
    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return orderCategory;
            },
            getOrderCategoryValue(){
                return orderCategoryFullName
            },
            focusIn() {
                var eInput = refInput.current;
                eInput.focus();
                eInput.select();
            },
        };
    });

    return (
        <Autocomplete
            options={orderCategoryOptions}
            value={(orderCategory && orderCategoryOptions.length > 0) ? (orderCategoryOptions.filter(obj => obj.value === orderCategory) ? orderCategoryOptions.filter(obj => obj.value === orderCategory)[0] : '') : ''}
            onChange={handleOrderCategoryChange}
            disableClearable
            PopperComponent={StyledPopper}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={'Select '}
                    inputRef={refInput}
                    className="customDatePickerDiscount"
                    size="small"
                    sx={{ fontSize: 'smaller', backgroundColor: theme.palette. background.paper }}
                />
            )}
        />
    );
});
const CLEAR_SELECTION = "__CLEAR__";

export const MultipleOrderCategoryEditorComponent = forwardRef((props, ref) => {
  const orderCategoryOptions = props.orderCategoryOptions || [];

  const [orderCategories, setOrderCategories] = useState(
    Array.isArray(props.value) ? props.value : [],
  );
  const [open, setOpen] = useState(false);

  const selectRef = useRef();
  const theme = useTheme();

  const realCategoryValues = orderCategoryOptions
    .filter((opt) => opt.value !== "ALL")
    .map((opt) => opt.value);

  const isAllSelected =
    realCategoryValues.length > 0 &&
    realCategoryValues.every((v) => orderCategories.includes(v)) &&
    orderCategories.length === realCategoryValues.length;

  const handleChange = (event) => {
    const values = event.target.value;

    if (values.includes(CLEAR_SELECTION)) {
      setOrderCategories([]);
      props.node.setDataValue("orderCategories", []);
      return;
    }

    if (values.includes("ALL")) {
      setOrderCategories(realCategoryValues);
      props.node.setDataValue("orderCategories", realCategoryValues);
      return;
    }

    setOrderCategories(values);
    props.node.setDataValue("orderCategories", values);
  };

  useImperativeHandle(ref, () => ({
    getValue() {
      return orderCategories;
    },

    focusIn() {
      selectRef.current?.focus();
    },
  }));

  const renderSelectedSummary = () => {
    if (!orderCategories || orderCategories.length === 0) {
      return <span style={{ opacity: 0.6 }}>Select Categories</span>;
    }

    if (isAllSelected) {
      return "ALL";
    }

    if (orderCategories.length === 1) {
      const option = orderCategoryOptions.find(
        (opt) => opt.value === orderCategories[0],
      );
      return option ? option.label : orderCategories[0];
    }

    return `${orderCategories.length} Categories Selected`;
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        width: "100%",
      }}
    >
      <Select
        multiple
        fullWidth
        displayEmpty
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        value={orderCategories}
        onChange={handleChange}
        renderValue={renderSelectedSummary}
        inputRef={selectRef}
        size="small"
        MenuProps={{
          transitionDuration: 150,
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: { vertical: "top", horizontal: "left" },
          PaperProps: {
            sx: {
              maxHeight: 320,
              mt: "2px",
              backgroundColor: theme.palette.background.paper,
              fontSize: "11px",
              "& .MuiList-root": {
                py: 0,
              },
            },
          },
        }}
        sx={{
          height: "100%",
          backgroundColor: theme.palette.background.paper,
          transition: "border-color 0.15s ease, box-shadow 0.15s ease",
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            height: "100% !important",
            paddingTop: 0,
            paddingBottom: 0,
            boxSizing: "border-box",
          },
        }}
      >
        <MenuItem
          value={CLEAR_SELECTION}
          dense
          sx={{
            fontStyle: "italic",
            opacity: 0.85,
            minHeight: "auto",
            fontSize: "11px",
            padding: "3px 8px",
          }}
        >
          Clear Selection
        </MenuItem>
        <Divider sx={{ my: 0 }} />
        {orderCategoryOptions.map((option) => {
          const checked =
            option.value === "ALL"
              ? isAllSelected
              : orderCategories.includes(option.value);

          return (
            <MenuItem
              key={option.value}
              value={option.value}
              dense
              sx={{ minHeight: "auto", fontSize: "11px", padding: "3px 8px" }}
            >
              <Checkbox size="small" checked={checked} sx={{ p: "2px", mr: "4px" }} />
              <ListItemText
                primary={option.label}
                primaryTypographyProps={{ fontSize: "11px" }}
              />
            </MenuItem>
          );
        })}
      </Select>
    </Box>
  );
});
export const CriteriaEditorComponent = forwardRef((props, ref) => {
    const [criteria, setCriteria] = useState(props.value||'ALL')
    const refInput = useRef();
     const theme = useTheme();
    const [criteriaOptions, setCriteriaOptions] = useState([
        'ALL',
        'Price Group',
        'Range',
        'Handle',
    ]);

    const handleCriteriaChange = (e, data) => {
        setCriteria(data);
        const rowData = props.node;
        rowData.setDataValue('criteria', data)
    };

    useEffect(() => {
        window.setTimeout(() => {
            const eInput = refInput.current;
            eInput.focus();
        });
    }, []);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return criteria;
            },
            getCriteria() {
                return criteria;
            },
            focusIn() {
                var eInput = refInput.current;
                eInput.focus();
                eInput.select();
            },
        };
    });

    return (
        <Autocomplete
            options={criteriaOptions}
            value={criteria}
            onChange={handleCriteriaChange}
            onInputChange={handleCriteriaChange}
            disableClearable
            PopperComponent={StyledPopper}
            renderInput={(params) => (
                <TextField
                    {...params}
                    size="small"
                    sx={{ fontSize: 'smaller', backgroundColor: theme.palette. background.paper }}
                    inputRef={refInput}
                    className="customDatePickerDiscount"
                    placeholder={'Select '}
                />
            )}
        />
    );
});

export const OrderTypeEditorComponent = forwardRef((props, ref) => {
    const [orderType, setOrderType] = useState(props.value || 'ALL')
    const refInput = useRef();
     const theme = useTheme();
    const [orderTypeOptions, setOrderTypeOptions] = useState([
        'ALL',
        'SO',
        'AO',
    ]);

    const handleOrderTypeChange = (e, data) => {
        setOrderType(data);
        const rowData = props.node;
        rowData.setDataValue('orderType', data)
    };

    useEffect(() => {
        window.setTimeout(() => {
            const eInput = refInput.current;
            eInput.focus();
        });
    }, []);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return orderType;
            },
            focusIn() {
                var eInput = refInput.current;
                eInput.focus();
                eInput.select();
            },
        };
    });

    return (
        <Autocomplete
            options={orderTypeOptions}
            value={orderType}
            onChange={handleOrderTypeChange}
            onInputChange={handleOrderTypeChange}
            disableClearable
            PopperComponent={StyledPopper}
            renderInput={(params) => (
                <TextField
                    {...params}
                    sx={{ fontSize: 'smaller', backgroundColor: theme.palette. background.paper }}
                    size="small"
                    inputRef={refInput}
                    className="customDatePickerDiscount"
                    placeholder={'Select '}
                />
            )}
        />
    );
});

export const PaymentTermEditorComponent = forwardRef((props, ref) => {
    const [paymentTerm, setPaymentTerm] = useState(props.value)
    const refInput = useRef();
    const [paymentTermOptions, setPaymentTermOptions] = useState([]);
    const [custId, setCustId] = useState(props.data.custNum);
    const [orderCat, setOrderCat] = useState(props.data.orderCategoryName);
    const [startDate, setStartDate] = useState(props.data.validFrom);
    const [endDate, setEndDate] = useState(props.data.validTo);
     const theme = useTheme();
    const handlePaymentTermChange = (e, data) => {
        setPaymentTerm(data.value);
        const rowData = props.node;
        rowData.setDataValue('paymentTerm', data.value)
    };

    useEffect(() => {
        window.setTimeout(() => {
            const eInput = refInput.current;
            eInput.focus();
        });
    }, []);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return paymentTerm;
            },
            focusIn() {
                var eInput = refInput.current;
                eInput.focus();
                eInput.select();
            },
        };
    });

    useEffect(() => {
        const paymentTerms = async () => {
                const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.paymentTerm}/linkToCustomer/search`;
                try {
                    const reqBody = {
                        customerCode: custId,
                        orderType: orderCat.toUpperCase() === 'PROJECT' || orderCat.toUpperCase() === 'PRJ' ? "PROJECT" : 'RETAIL',
                        startDate: startDate && moment(startDate).format('YYYY-MM-DD'),
                        endDate: endDate && moment(endDate).format('YYYY-MM-DD'),
                    }
                    const paymentTermList = await OAuthService.addData(url, reqBody);
                    const result = []
                    paymentTermList?.data?.map((value) => {
                        if(result.length > 0){
                            if(result.filter(data => data.value === value?.paymentTerm?.code).length <= 0){
                                result.push({ label: value?.paymentTerm?.code, value: value?.paymentTerm?.code });
                            }
                        }else{
                            result.push({ label: value?.paymentTerm?.code, value: value?.paymentTerm?.code });
                        }
                    });
                    setPaymentTermOptions(result);
                } catch (error) {
                }
        }
        paymentTerms()
    }, [custId,orderCat,startDate,endDate])

    const handleFocus = () => {
        props.api?.getCellEditorInstances().map((editor) => {
            if (editor?.getCustNum) {
                setCustId(editor.getCustNum());
            }
            if (editor?.getOrderCategoryValue) {
                setOrderCat(editor.getOrderCategoryValue());
            }
            if (editor?.getToDate) {
                setEndDate(editor.getToDate());
            }
            if (editor?.getFromDate) {
                setStartDate(editor.getFromDate());
            }
        })
    }

    useEffect(() => {
        props.api?.getCellEditorInstances().map((editor) => {
            if (editor?.getCustNum) {
                setCustId(editor.getCustNum());
            }
            if (editor?.getOrderCategoryValue) {
                setOrderCat(editor.getOrderCategoryValue());
            }
            if (editor?.getToDate) {
                setEndDate(editor.getToDate());
            }
            if (editor?.getFromDate) {
                setStartDate(editor.getFromDate());
            }
        })
    }, []);

    return (
        <Autocomplete
            options={paymentTermOptions}
            value={(paymentTerm && paymentTermOptions.length > 0) ? (paymentTermOptions.filter(obj => obj.value === paymentTerm) ? paymentTermOptions.filter(obj => obj.value === paymentTerm)[0] : '') : ''}
            onChange={handlePaymentTermChange}
            onFocus={handleFocus}
            disableClearable
            PopperComponent={StyledPopper}
            renderInput={(params) => (
                <TextField
                    {...params}
                    sx={{ fontSize: 'smaller', backgroundColor: theme.palette. background.paper }}
                    size="small"
                    inputRef={refInput}
                    className="customDatePickerDiscount"
                    placeholder={'Select '}
                />
            )}
        />
    );
});